// import { VwdOption } from '@vwd/vwd-pilldown';

export class SettingsBox {
  constructor(
    public interestRate: number,

    public issueDate: Date,

    public firstCouponDate: Date,

    public lastCouponDate: Date,

    public maturityDate: Date,

    public redemptionPrice: number,

    public couponFrequency: number,

    public lastCouponDateOptionList: any[],

    public valueDate?: Date,

    public calculationMethod?: string,

    public taxRate?: number,

    public nominalVolume?: number,

    public dayCountConvention?: string,

    public isDefault?: boolean
  ) { }
}


